import { memo } from 'react';
import { AdminFormRow } from '@ui';
import { TXUserRoleCreateForm } from '../TXRoleForm';
import { IS_PROD } from '@/constants/env.constants';
import { ControlledTextInput } from '../components/inputs/ControlledTextInput';
import { ControlledPhoneInput } from '../components/inputs/ControlledPhoneInput';

type TXUserFormBaseProps = {
  isReadOnly?: boolean;
  isHidden?: boolean;
};

export const TXUserFormBase = memo(({ isReadOnly = false, isHidden = true }: TXUserFormBaseProps) => {
  const enableMultipleCountries = !IS_PROD;

  return (
    <>
      <AdminFormRow title="First Name" isRequired>
        <ControlledTextInput
          name="firstName"
          aria-label="Contact First Name"
          isReadOnly={isReadOnly}
          isDisabled={isReadOnly}
        />
      </AdminFormRow>
      <AdminFormRow title="Last Name" isRequired>
        <ControlledTextInput
          name="lastName"
          aria-label="Contact Last Name"
          isReadOnly={isReadOnly}
          isDisabled={isReadOnly}
        />
      </AdminFormRow>
      {!isHidden && <TXUserRoleCreateForm isReadOnly={isReadOnly} />}
      <AdminFormRow title="Email" isRequired>
        <ControlledTextInput
          name="email"
          aria-label="Contact Email"
          type="email"
          isReadOnly={isReadOnly}
          isDisabled={isReadOnly}
        />
      </AdminFormRow>
      <AdminFormRow title="Primary Phone" inputWrapperClass="max-w-[20rem]" isRequired>
        <ControlledPhoneInput
          name="primaryPhone"
          disabled={isReadOnly}
          enableMultipleCountries={enableMultipleCountries}
        />
      </AdminFormRow>
      <AdminFormRow title="Secondary Phone" inputWrapperClass="max-w-[20rem]">
        <ControlledPhoneInput
          name="secondaryPhone"
          disabled={isReadOnly}
          enableMultipleCountries={enableMultipleCountries}
        />
      </AdminFormRow>
    </>
  );
});
